module.exports = __webpack_public_path__ + "img/1.3fd4439e.png";